__webpack_require__.p = "https://dashboard.cdn.gifty.nl/6048/";